export default __webpack_public_path__ + "static/media/second-right-img-2x.53e8fc76.png";